<template>
    <b-row>
        <b-col cols="9">
            <validation-observer ref="observer" v-slot="{ passes, invalid }">
                <b-modal title="Close Fulfillment" id="confirm-close-fulfillment-modal" ok-title="Close Fulfillment"
                         v-model="showCompleteModal"
                         :ok-disabled="invalid"
                         :busy="isBusy"
                         @ok="handleCompleteOk">
                    <h5>Please double check that fulfillment is complete for the day prior to proceeding.</h5>
                </b-modal>
            </validation-observer>
            <b-row>
                <b-col class="workspace-header" id="actions_header">
                    <b-dropdown split split-variant="primary" variant="dark" :disabled="disableActions"
                                @click="printSelected" class="mr-2" v-if="!pageIsReview">
                        <template v-slot:button-content>
                            <i class="fa-solid fa-print fa-fw"></i><strong> Print Selected Kit(s)</strong>
                        </template>
                        <b-dropdown-item @click="printSelected"><i
                            class="fa-regular fa-envelopes-bulk fa-fw"></i><strong> Print All Kit Assets</strong>
                        </b-dropdown-item>
                        <b-dropdown-divider></b-dropdown-divider>
                        <b-dropdown-item @click="printSelectedIndividual('welcome_letter')"><i
                            class="fa-regular fa-file-lines fa-fw"></i> Print Welcome Letter <strong>Only</strong>
                        </b-dropdown-item>
                        <b-dropdown-item @click="printSelectedIndividual('fedex')"><i
                            class="fa-regular fa-truck-arrow-right fa-fw"></i> Print Shipping Label <strong>Only</strong>
                        </b-dropdown-item>
                        <b-dropdown-item @click="printSelectedIndividual('usps')"><i
                            class="fa-regular fa-envelope fa-fw"></i> Print Address Label <strong>Only</strong>
                        </b-dropdown-item>
                        <b-dropdown-item @click="printSelectedIndividual('order')"><i
                            class="fa-regular fa-rectangle-barcode fa-fw"></i> Print Order Labels <strong>Only</strong>
                            (3x)
                        </b-dropdown-item>
                    </b-dropdown>

                    <b-dropdown variant="light" size="sm" class="mr-2" v-if="!pageIsReview" v-show="false">
                        <template v-slot:button-content>
                            <i class="fa-regular fa-file-image fa-fw"></i> Printing on <strong>Letterhead</strong>
                        </template>
                        <b-dropdown-item @click="printSelectedIndividual('welcome_letter')"><i
                            class="fa-solid fa-check fa-fw text-info"></i><i class="fa-regular fa-file-image fa-fw"></i>Print
                            on Letterhead
                        </b-dropdown-item>
                        <b-dropdown-item @click="printSelectedIndividual('fedex')"><i
                            class="fa-regular fa- fa-fw text-info"></i><i class="fa-regular fa-file fa-fw"></i>Print on
                            Plain Paper
                        </b-dropdown-item>
                    </b-dropdown>

                    <b-dropdown variant="light" size="sm" class="mr-2" :disabled="disableActions" v-if="!pageIsReview">
                        <template v-slot:button-content>
                            <i class="fa-regular fa-edit fa-fw"></i> Mark as...
                        </template>
                        <b-dropdown-item @click="markDoNotPrintSelected"><i
                            class="fa-regular fa-print-slash fa-fw text-warning"></i>Mark as Do Not Print
                        </b-dropdown-item>
                        <b-dropdown-item @click="markFailedSelected"><i
                            class="fa-regular fa-times fa-fw text-danger"></i>Mark as Failed
                        </b-dropdown-item>
                        <b-dropdown-item @click="markReadySelected"><i
                            class="fa-regular fa-check fa-fw text-success"></i>Mark as Ready
                        </b-dropdown-item>
                    </b-dropdown>

                    <b-button variant="warning" @click="closeFulfillment" size="sm" :disabled="isBusy">
                        <i class="fa-regular fa-print-slash fa-fw"></i> Close Fulfillment (EOD)
                    </b-button>
                </b-col>

                <b-col cols="2" class="workspace-header">
                    <h1 class="text-right">Fulfillment</h1>
                </b-col>
            </b-row>

            <b-row>
                <b-col>
                    <b-card>
                        <b-row>
                            <b-col class="mb-4">
                                <b-row>
                                    <b-col cols="4">
                                        <b-form>
                                            <b-input-group>
                                                <b-form-input v-model="search" :disabled="isBusy"
                                                              placeholder="Type to search"></b-form-input>
                                                <b-input-group-append>
                                                    <b-button :disabled="isBusy" @click="clearFilter">Clear</b-button>
                                                </b-input-group-append>
                                            </b-input-group>
                                        </b-form>
                                    </b-col>
                                    <b-col>
                                        <div class="d-inline-block pr-2 mr-4 b-r-1" v-if="!pageIsReview">
                                            <i class="fa-regular fa-institution fa-fw mr-2"></i> <label class="mb-0">Brand</label>
                                            <b-form-group class="mb-0">
                                                <b-form-radio-group
                                                    v-model="brandSelected"
                                                    :options="brandOptions"
                                                    name="brand-radio-inline"
                                                ></b-form-radio-group>
                                            </b-form-group>
                                        </div>
                                        <div class="d-inline-block" v-if="!pageIsReview">
                                            <i class="fa-regular fa-map-marker-alt fa-fw mr-2"></i> <label class="mb-0">Fulfillment
                                            Location</label>
                                            <b-form-group class="mb-0">
                                                <b-form-radio-group
                                                    v-model="fulfillmentLocationSelected"
                                                    :options="fulfillmentLocationOptions"
                                                    name="location-radio-inline"
                                                ></b-form-radio-group>
                                            </b-form-group>
                                        </div>
                                    </b-col>
                                    <b-col cols="1" class="text-right">
                                        <b-button-group>
                                            <b-button title="Refresh List" @click="$refs.fulfillmentTable.refreshData()"
                                                      :disabled="isBusy"><i class="fa-regular fa-sync"></i></b-button>
                                        </b-button-group>
                                    </b-col>
                                </b-row>
                            </b-col>
                        </b-row>

                        <router-view ref="fulfillmentTable"></router-view>

                    </b-card>
                </b-col>
            </b-row>
        </b-col>

        <b-col cols="3">

            <b-row>
                <b-col>
                    <dashboard-side-data-widget label="Ready To Print" clickable
                                                to="/fulfillment/ready"
                                                :data="dashboardData.readyCount"
                                                :overviewData="[{'label': 'FL', 'data': dashboardData.readyCountFL}, {'label': 'KS', 'data': dashboardData.readyCountKS}]"
                                                :colorData="dashboardData.readyCount > 0 ? 'info' : '' "
                                                :colorAccent="dashboardData.readyCount > 0 ? 'info' : '' "
                                                icon="fa-light fa-print">
                    </dashboard-side-data-widget>
                    <dashboard-side-data-widget label="Printed" clickable
                                                to="/fulfillment/printed"
                                                :data="dashboardData.printedCount"
                                                :overviewData="[{'label': 'FL', 'data': dashboardData.printedCountFL}, {'label': 'KS', 'data': dashboardData.printedCountKS}]"
                                                :colorData="dashboardData.printedCount > 0 ? 'success' : '' "
                                                :colorAccent="dashboardData.printedCount > 0 ? 'success' : '' "
                                                icon="fa-light fa-check-circle">
                    </dashboard-side-data-widget>
                    <dashboard-side-data-widget label="Failed" clickable
                                                to="/fulfillment/failed"
                                                :data="dashboardData.failedCount"
                                                :colorData="dashboardData.failedCount > 0 ? 'danger' : '' "
                                                :colorAccent="dashboardData.failedCount > 0 ? 'danger' : '' "
                                                icon="fa-light fa-print-slash">
                    </dashboard-side-data-widget>
                    <dashboard-side-data-widget label="Needing Review" clickable
                                                to="/fulfillment/review"
                                                :data="dashboardData.reviewCount"
                                                :colorData="dashboardData.reviewCount > 0 ? 'warning' : '' "
                                                :colorAccent="dashboardData.reviewCount > 0 ? 'warning' : '' "
                                                icon="fa-light fa-clipboard-list-check">
                    </dashboard-side-data-widget>
                </b-col>
            </b-row>
        </b-col>
    </b-row>
</template>

<script>
import Lead from '@/models/Lead';
import DashboardSideDataWidget from '@/components/DashboardSideDataWidget';
import {BROADCAST_CONNECTED} from '@/store/actions';
import _, {assign, each} from 'lodash';
import AppraisalKit from '@/models/AppraisalKit';


export default {
    name: 'fulfillment-index',
    title: 'Fulfillment',
    data() {
        return {
            dashboardData: {
                readyCount: null,
                printedCount: null,
                failedCount: null,
                reviewCount: null,
            },
            search: '',
            allCount: {},
            perPage: 25,
            currentPage: 1,
            isBusy: false,
            sortBy: 'requested_at',
            sortDesc: false,
            totalRows: 0,
            filter: '',
            fields: [
                {key: 'selected', class: 'text-center', sortable: false},
                {key: 'order.id', label: 'Order #', class: 'text-center', sortable: true},
                {key: 'customer.id', label: 'Customer #', class: 'text-center', sortable: true},
                {key: 'requested_at', label: 'Request Date', class: 'text-center', sortable: true},
                {key: 'name', class: 'text-center', sortable: false},
                {key: 'brand.name', label: 'Brand', class: 'text-center', sortable: true},
                {key: 'status', class: 'text-center', sortable: false},
            ],
            items: [],
            selected: [],
            allSelected: false,
            showCompleteModal: null,
            LAST_PRINTED: 0,
            LAST_PRINTED_TTL_RESET: 5,
            LAST_PRINTED_TTL: this.LAST_PRINTED_TTL_RESET,
            PRINT_QUEUE: [],
            ERROR_QUEUE: [],
            PRINT_QUEUE_TIMER: null,
            fulfillmentLocationSelected: 'global',
            fulfillmentLocationOptions: [
                {text: 'Global', value: 'global'},
                {text: 'Florida', value: 'florida'},
                {text: 'Kansas', value: 'kansas'}
            ],
            brandSelected: 'all',
            brandOptions: [{text: 'All', value: 'all'}, 'SYG', 'GK', 'RP', 'TWB', 'OOYL'],
            settings: {},
            pageIsReview: false,
        };
    },
    components: {
        DashboardSideDataWidget,
    },
    created() {
        this.$qz.connect();
        this.settings = JSON.parse(localStorage.getItem('settings')) || false;
        if (this.settings && this.settings.fulfillmentCenter) {
            this.fulfillmentLocationSelected = this.settings.fulfillmentCenter;
        }
    },
    beforeDestroy() {
        clearInterval(this.PRINT_QUEUE_TIMER);

        console.info(String.fromCodePoint(0x1F44B) + ' Leaving App.Fulfillment channel from Fulfillment/index.vue.');
        this.$echo.leaveChannel('App.Fulfillment');
    },
    destroyed() {
//            this.$qz.disconnect();
    },
    mounted() {
        this.getDashboardData();

        // Start processing queue
        this.PRINT_QUEUE_TIMER = window.setInterval(this.processPrintQueue, 1000);

        console.info(String.fromCodePoint(0x1F6F0) + '%c Broadcast Connected:', 'color:yellow;', this.$store.getters.isBroadcastConnected);
        if (!this.$store.getters.isBroadcastConnected) {
            this.$store.subscribe((mutation) => {
                console.log('%cSubscribe mutation ' + mutation.type, 'color:gray;');
                if (mutation.type === BROADCAST_CONNECTED) {
                    console.info(String.fromCodePoint(0x1F504) + '%c Joining via BROADCAST_CONNECTED mutation.', 'color:green;');
                    this.joinBroadcastChannel();
                }
            });
        } else {
            console.info(String.fromCodePoint(0x2757) + '%c Joining via isBroadcastConnected getter.', 'color:teal;');
            this.joinBroadcastChannel();
        }
    },
    watch: {
        '$route.path'() {
            if (this.$route.path === '/fulfillment/review') {
                this.pageIsReview = true;
            } else {
                this.pageIsReview = false;
            }
        },
        fulfillmentLocationSelected: function () {
            this.$refs.fulfillmentTable.refreshData();
        },
        brandSelected: function () {
            this.$refs.fulfillmentTable.refreshData();
        },
        allSelected: function (val) {
            if (val === true) {
                this.$refs.fulfillmentTable.selectAllRows();
            } else {
                this.$refs.fulfillmentTable.clearSelected();
            }
        },
    },
    computed: {
        disableActions: function () {
            return this.selected.length <= 0;
        },
    },
    methods: {
        joinBroadcastChannel: function () {
            console.info(String.fromCodePoint(0x1F91D) + ' Joining App.Fulfillment channel from Fulfillment/index.vue.');
            this.$echo.channel('App.Fulfillment')
                .listen('BroadcastDashboardUpdate', (e) => {
                    this.dashboardData = assign(this.dashboardData, e.payload[0]);
                });
        },

        getDashboardData() {
            this.$http.get('/countAll',).then((response) => {
                this.dashboardData = assign(this.dashboardData, response.data.data[0]);
            });
        },

        // Common Methods

        getItems() {
            return _.filter(this.items, (e) => {
                if (!e.customer) {
                    return false;
                }
                let matchingPointers = this.search.split(' ');
                for (let i = 0; i < matchingPointers.length; i++) {
                    if (
                        e.customer.first_name.toLowerCase().includes(matchingPointers[i].toLowerCase())
                        || e.customer.last_name.toLowerCase().includes(matchingPointers[i].toLowerCase())
                        || e.customer.id == (matchingPointers[i])
                        || e.order.id == (matchingPointers[i])
                    ) {
                        continue;
                    }
                    return false;
                }
                return true;
            });
        },

        clearFilter() {
            this.filter = '';
            this.search = '';
        },

        closeFulfillment() {
            this.showCompleteModal = true;
        },

        handleCompleteOk() {
            this.isBusy = true;
            this.$http.get('fulfillment/finished_report')
            .then(() => {
                this.isBusy = false;
            });
        },

        rowClass(item) {
            if (!item) return;
            if (item.status === 'printed') return 'table-success';
        },

        processPrintQueue(vm) {
            for (let i = 0; i < this.PRINT_QUEUE.length; i++) {
                let nextItem = this.PRINT_QUEUE[i];
                if (nextItem.item.status === 'printing' || nextItem.item.status === 'downloading') {
                    break;
                }
                if (nextItem.item.status === 'downloaded') {
                    //console.log(nextItem);
                    this.printAppraisalKit(vm, nextItem.item, nextItem.asset);
                    break;
                }
            }
        },

        // Used by Print Queue
        async printAppraisalKit(vm, item, appraisalKit) {

            // If order is changing, delay through TTL iterations
            if ((item.order.id !== this.LAST_PRINTED) && (this.LAST_PRINTED_TTL)) {
                this.LAST_PRINTED_TTL--;
                return;
            }

            this.LAST_PRINTED = item.order.id;
            this.LAST_PRINTED_TTL = this.LAST_PRINTED_TTL_RESET;

            item.status = 'printing';
            let lead = new Lead({id: item.id});

            let promise = new Promise(async (resolve) => {
                this.$label('fulfillment_order', item, 'barcode');
                await this.$label('address', item, 'barcode');

                this.$printer.print('fedex', appraisalKit.inbound_shipping.label.label);
                if (process.env.NODE_ENV !== 'production') {
                    //this.$label('fedex', {order_id: item.order.id, tracking_number: appraisalKit.inbound_shipping.tracking_number}, 'barcode');
                }

                this.$printer.printPDF('letterhead', appraisalKit.welcome_letter.file_path);


                let response = lead.markPrinted();

                response.then(() => {
                    item.status = 'printed';
                }).catch(() => {
                    console.log('error');
                });

                resolve(response);
            });

            return promise.then(response => {
                // setTimeout(() => {
                //     vm.items = vm.items.filter((elem) => {
                //         return elem.id !== lead.id;
                //     });
                // }, 2000);

                return response;
            });
        },

        // Used by printSelectedIndividual
        printAppraisalKitIndividual: (vm, item, appraisalKit, option, originalStatus) => {
            item.status = 'printing';
            let lead = new Lead({id: item.id});

            switch (option) {
                case 'order':
                    vm.$label('fulfillment_order', item, 'barcode');
                    break;
                case 'fedex':
                    vm.$printer.print('fedex', appraisalKit.inbound_shipping.label.label);
                    if (process.env.NODE_ENV !== 'production') {
                        vm.$label('fedex', {
                            order_id: item.order.id,
                            tracking_number: appraisalKit.inbound_shipping.tracking_number
                        }, 'barcode');
                    }
                    break;
                case 'usps':
                    vm.$label('address', item, 'barcode');
                    break;

                case 'welcome_letter':
                    vm.$printer.printPDF('letterhead', appraisalKit.welcome_letter.file_path);
                    break;
            }

            let promise = new Promise((resolve) => {
                console.log(item);
                let response = lead.markPrinted();

                response.then(() => {
                    item.status = originalStatus;
                }).catch(() => {
                    console.log('error');
                });

                resolve(response);
            });

            return promise.then(response => {
                // setTimeout(() => {
                //     vm.items = vm.items.filter((elem) => {
                //         return elem.id !== lead.id;
                //     });
                // }, 2000);

                return response;
            });
        },

        // User Actions
        // Print entire kit for selected
        async printSelected() {
            let vm = this;

            if (!vm.selected.length) {
                console.log('There are no rows selected.');

                return;
            }

            each(vm.selected, async (item) => {
                let promise = new Promise((resolve) => {
                    let lead = new Lead({id: item.id});

                    item.status = 'downloading';

                    let response = new AppraisalKit()
                        .for(lead)
                        .$first();

                    resolve(response);
                });

                return await promise.then(async (response) => {
                    let appraisalKit = response;

                    item.status = 'downloaded';

                    item.order.mail_tracking_number = appraisalKit.inbound_shipping.tracking_number;

                    // TODO add to queue
                    //await vm.printAppraisalKit(vm, item, appraisalKit);
                    //console.log('assets:', item, appraisalKit);
                    if (!_.find(this.PRINT_QUEUE, {order_id: item.order.id, item: item, asset: appraisalKit})) {
                        this.PRINT_QUEUE.push({
                            order_id: item.order.id,
                            item: item,
                            asset: appraisalKit,
                            //data: null,
                            //status: 'downloaded',
                        });
                    }

                    return appraisalKit || [];
                });
            });
            this.$refs.fulfillmentTable.clearSelected();
        },

        // Print individual asset for selected
        printSelectedIndividual(option) {
            let vm = this;

            if (!vm.selected.length) {
                console.log('There are no rows selected.');

                return;
            }

            each(vm.selected, (item) => {
                let originalStatus = item.status;
                let promise = new Promise((resolve) => {
                    let lead = new Lead({id: item.id});

                    item.status = 'downloading';

                    let response = {};

                    switch (option) {
                        case 'order':
                            resolve(response);
                            break;
                        case 'fedex':
                            this.$http.get('/leads/' + lead.id + '/inbound-shipping', 'json')
                                .then(res => {
                                    response.inbound_shipping = res.data.data;
                                    resolve(response);
                                });
                            break;
                        case 'usps':
                            resolve(response);
                            break;
                        case 'welcome_letter':
                            this.$http.get('/leads/' + lead.id + '/welcome-letter')
                                .then(res => {
                                    response.welcome_letter = res.data.data;
                                    resolve(response);
                                });
                            break;
                    }
                });

                return promise.then((response) => {
                    let appraisalKit = response;

                    console.log(appraisalKit);
                    item.status = 'downloaded';

                    // TODO add to queue
                    vm.printAppraisalKitIndividual(vm, item, appraisalKit, option, originalStatus);

                    return appraisalKit || [];
                });
            });
        },

        markDoNotPrintSelected() {
            let vm = this;

            each(vm.selected, (item) => {
                item.status = 'do-not-print';
                let lead = new Lead({id: item.id});
                lead.markDoNotPrint().then(() => {
                    vm.items = vm.items.filter((elem) => {
                        return elem !== item;
                    });
                });
            });
        },

        markFailedSelected() {
            let vm = this;

            each(vm.selected, (item) => {
                item.status = 'failed';
                let lead = new Lead({id: item.id});
                lead.markFailed().then(() => {
                    vm.items = vm.items.filter((elem) => {
                        return elem !== item;
                    });
                });
            });
        },

        markReadySelected() {
            let vm = this;

            each(vm.selected, (item) => {
                item.status = 'ready';
                let lead = new Lead({id: item.id});
                lead.markReadyToPrint().then(() => {
                    vm.items = vm.items.filter((elem) => {
                        return elem !== item;
                    });
                });
            });
        },

    },
};
</script>

<style scoped>

</style>
